import { UltraHighDefinitionIcon } from './UltraHighDefinitionIcon';

/**
 * author: Austin Andrews
 * id A7C08392-F82F-4910-8D0F-6A1907AE19E3
 * name ultra-high-definition
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ultra-high-definition.svg
 * tags
 * - Video / Movie 
 */
export const UhdIcon = UltraHighDefinitionIcon;
export default UhdIcon